import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Collapse,
  FormControlLabel,
  FormGroup,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Rating,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import { CURRENCY, ORDER_STATUS_TRANSITIONS } from "../../constants/Variables";
import { CompanyRoutes } from "../../routes";
import { getVariantLabel, roundTo2Decimal } from "../../utils";
import GlobalButton from "../CustomButton";
import CustomSwitch from "../CustomSwitch";
import CustomDropDown from "../CutomDropDown";
import IOSSwitch from "../IsoSwitch";

const tableStyle = {
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: appcolors.primary,
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      padding: "6px 16px",
      color: appcolors.white,
      fontSize: "0.875rem",
    },
  "& .view_btn": {
    border: "1px solid grey",
    height: 35,
    width: 75,
    fontSize: "0.875rem",
    borderRadius: "6px",
  },
};

const PRODUCT_STATUS = [
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Processing",
    value: "processing",
  },
  {
    label: "Shipped",
    value: "shipped",
  },
  {
    label: "Delivered",
    value: "delivered",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  },
  // {
  //   label: "User Cancelled",
  //   value: "user_cancelled",
  // },
];

export default function GlobalTable({
  tableWidth,
  minWidth,
  tableHeader,
  tableData,
  displayRows,
  showEdit,
  showDelete,
  showView,
  showActions,
  handleEdit,
  handleDelete,
  handleViewDetail,
  showPagination = true,
  handleChangeOrderStatus,
  showDetailBtn,
  handleNavigateToDetail,
  handleChangeStatus,
  handleSeePricing,
  handleSeeDuration,
  handleRefund,
  showAdminUserPage = false,
  isBulkMode = false,
  pendingStatusChanges = {},
}) {
  const openPackageProductsDialog = useRef();
  const openDetailRef = useRef(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [meunAnchorEl, setMenuAnchorEl] = useState(null);
  const openAddEditMenu = Boolean(meunAnchorEl);
  const [rowData, setRowData] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const handleClickAddEditMenu = (event, row, index) => {
    setMenuAnchorEl(event.currentTarget);
    setRowData({ row, index });
  };

  const handleCloseAddEditMenu = () => {
    setMenuAnchorEl(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleTogglePagesRow = (rowIndex) => {
    setExpandedRow(expandedRow === rowIndex ? null : rowIndex);
  };

  const orderStatusColors = (status) => {
    if (status === "pending") return "orange";
    if (status === "processing") return "blue";
    if (status === "shipped") return "purple";
    if (status === "delivered") return "green";
    if (status === "cancelled") return "red";
    if (status === "user_cancelled") return "red";
  };

  const renderColorBox = (colorname, color) => {
    return (
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          border: "1px solid #ccc",
          borderRadius: 1,
          padding: "4px 8px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <Box
          sx={{
            fontSize: "14px",
            color: "#333",
            fontWeight: 500,
            marginRight: "8px",
          }}
        >
          {colorname}
        </Box>
        <Box
          sx={{
            width: 18,
            height: 18,
            borderRadius: "50%",
            backgroundColor: color,
            border: "1px solid #ddd",
          }}
        ></Box>
      </Stack>
    );
  };

  return (
    <>
      <TableContainer sx={tableStyle}>
        <Table
          sx={{
            width: tableWidth ? tableWidth : "100%",
            minWidth: minWidth ? minWidth : "900px",
          }}
        >
          <TableHead>
            <TableRow>
              {tableHeader?.map((header) => (
                <TableCell key={header}>{t(header)}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? tableData?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage,
                )
              : tableData
            )?.map((row, index) => {
              let productPrice = row.discount > 0 ? row.discount : row.price;

              const variantLabel = row?.selectedVariant
                ? getVariantLabel(
                    row?.selectedVariant?.attributes,
                    currentLanguage,
                  )
                : null;

              return (
                <>
                  <TableRow key={index}>
                    {displayRows.map((val) => (
                      <React.Fragment key={val}>
                        {val === "created_date" ? (
                          <TableCell>
                            {moment(row.createdAt).format("DD/MM/YYYY")}
                            <br />
                            {moment(row.createdAt).format("hh:mm:ss a")}
                          </TableCell>
                        ) : val === "avarar_image" ? (
                          <TableCell>
                            <Avatar
                              src={row.image}
                              sx={{
                                height: 60,
                                width: 60,
                                borderRadius: 2,
                              }}
                            />
                          </TableCell>
                        ) : val === "showUserImage" ? (
                          <TableCell>
                            <Avatar
                              src={row.profileImg}
                              sx={{
                                height: 60,
                                width: 60,
                                borderRadius: 2,
                              }}
                            />
                          </TableCell>
                        ) : val === "product_name" ? (
                          <TableCell>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              gap={1}
                              width={"400px"}
                            >
                              <Avatar
                                src={row?.productId?.coverImage}
                                sx={{
                                  height: 55,
                                  width: 55,
                                  borderRadius: "6px",
                                  backgroundColor: "#edebeb",
                                  border: "1px solid #edebeb",
                                }}
                              />
                              <Typography
                                variant={"body1"}
                                textTransform={"capitalize"}
                              >
                                {row?.productId?.name[currentLanguage]}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val === "order_product_variant" ? (
                          <TableCell>
                            {row?.selectedVariant ? (
                              <Chip
                                sx={{ borderRadius: 1 }}
                                label={variantLabel || "Selected variant"}
                              />
                            ) : (
                              "_"
                            )}
                          </TableCell>
                        ) : val === "order_product_quantity" ? (
                          <TableCell>{`${row.selectedQty}`}</TableCell>
                        ) : val === "order_product_unit_price" ? (
                          <TableCell>{`${row.pricing?.price} ${CURRENCY}`}</TableCell>
                        ) : val === "order_product_profit_margin" ? (
                          <TableCell>{`${row.pricing?.profitMargin}%`}</TableCell>
                        ) : val === "order_product_discount" ? (
                          <TableCell>{`${row.pricing?.discount}`}</TableCell>
                        ) : val === "order_product_final_price" ? (
                          <TableCell>{`${row.pricing?.finalPrice} ${CURRENCY}`}</TableCell>
                        ) : val === "order_product_vat" ? (
                          <TableCell>{`${row.pricing?.vat}%`}</TableCell>
                        ) : val === "order_product_vat_amount" ? (
                          <TableCell>{`${row.pricing?.originalVatAmount} ${CURRENCY}`}</TableCell>
                        ) : val === "product_price" ? (
                          <TableCell>{productPrice}</TableCell>
                        ) : val === "order_product_amount_after_vat" ? (
                          <TableCell>{`${roundTo2Decimal(row.pricing?.originalVatAmount + row.pricing?.finalPrice)} ${CURRENCY}`}</TableCell>
                        ) : val === "product_tax" ? (
                          <TableCell>{row.tax}%</TableCell>
                        ) : val === "product_final_amount" ? (
                          <TableCell>
                            {`${CURRENCY} ${row.finalPrice}`}
                          </TableCell>
                        ) : val === "product_final_price" ? (
                          <TableCell>
                            {`${CURRENCY} ${row.finalPrice * row.selectedQty}`}
                          </TableCell>
                        ) : val === "product_selected_size" ? (
                          <TableCell>
                            {row?.selectedSize?.name ? (
                              <Chip
                                sx={{ borderRadius: 1 }}
                                label={row?.selectedSize?.name}
                              />
                            ) : row.selectedSizeWithColor ? (
                              <Chip
                                sx={{ borderRadius: 1 }}
                                label={row?.selectedSizeWithColor?.size}
                              />
                            ) : (
                              "_"
                            )}
                          </TableCell>
                        ) : val === "product_selected_color" ? (
                          <TableCell>
                            {row?.selectedColor?.color
                              ? renderColorBox(
                                  row?.selectedColor?.colorName,
                                  row?.selectedColor?.color,
                                )
                              : row.selectedSizeWithColor
                                ? renderColorBox(
                                    row?.selectedSizeWithColor?.colorName,
                                    row?.selectedSizeWithColor?.color,
                                  )
                                : "_"}
                          </TableCell>
                        ) : val === "user_image_name" ? (
                          <TableCell>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              gap={1}
                            >
                              <Avatar src={row.profileImg} />
                              <Typography>
                                {`${row.firstname} ${row.lastname}`}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val === "customerStatus" ? (
                          <TableCell>
                            <CustomSwitch
                              checked={row.status}
                              onChange={(ee) =>
                                handleChangeStatus(ee.target.checked, row)
                              }
                            />
                          </TableCell>
                        ) : val === "product_selected_weight" ? (
                          <TableCell>
                            {row?.selectedWeight ? (
                              <Chip
                                sx={{ borderRadius: 1 }}
                                label={row?.selectedWeight?.name}
                              />
                            ) : (
                              "_"
                            )}
                          </TableCell>
                        ) : val === "product_status" ? (
                          <TableCell sx={{ width: 200 }}>
                            {[
                              "user_cancelled",
                              "cancelled",
                              "delivered",
                            ].includes(row?.orderStatus) &&
                            row?.showDropdown === false ? (
                              <Chip
                                size="small"
                                label={row?.orderStatus?.replace("_", " ")}
                                sx={{
                                  backgroundColor: orderStatusColors(
                                    row.orderStatus,
                                  ),
                                  textTransform: "capitalize",
                                  color: "white",
                                }}
                              />
                            ) : (
                              (() => {
                                // Single source of truth: whichever status is actually being shown
                                // (pending bulk selection, or the saved status) drives BOTH the
                                // dropdown's selected value and its color.
                                const effectiveStatus = isBulkMode
                                  ? (pendingStatusChanges[row._id] ??
                                    row.orderStatus)
                                  : row.orderStatus;

                                return (
                                  <CustomDropDown
                                    sx={{
                                      color: orderStatusColors(effectiveStatus),
                                    }}
                                    value={effectiveStatus}
                                    onChange={(e) =>
                                      handleChangeOrderStatus(
                                        e.target.value,
                                        row,
                                        index,
                                      )
                                    }
                                    formStyleProps={{
                                      "& .MuiSelect-select": {
                                        textTransform: "capitalize",
                                      },
                                    }}
                                  >
                                    {PRODUCT_STATUS.map((val, index) => {
                                      const savedStatus =
                                        row?.savedOrderStatus ??
                                        row?.orderStatus;
                                      // const isReverse =
                                      //   (savedStatus === "processing" &&
                                      //     val.value === "pending") ||
                                      //   (savedStatus === "shipped" &&
                                      //     val.value === "pending") ||
                                      //   (savedStatus === "shipped" &&
                                      //     val.value === "processing") ||
                                      //   (savedStatus === "delivered" &&
                                      //     (val.value === "pending" ||
                                      //       val.value === "processing" ||
                                      //       val.value === "shipped"));
                                      const isReverse =
                                        val.value !== savedStatus &&
                                        !ORDER_STATUS_TRANSITIONS[
                                          savedStatus
                                        ]?.includes(val.value);
                                      return (
                                        <MenuItem
                                          key={index}
                                          value={val.value}
                                          disabled={isReverse}
                                          sx={{
                                            color: orderStatusColors(val.value),
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {val.label}
                                        </MenuItem>
                                      );
                                    })}
                                  </CustomDropDown>
                                );
                              })()
                            )}
                          </TableCell>
                        ) : val === "product_delivered_at" ? (
                          <TableCell>
                            {row?.deliveredAt ? (
                              <Stack p={0.5}>
                                {moment(row?.deliveredAt).format("DD/MM/YYYYY")}
                              </Stack>
                            ) : (
                              "_"
                            )}
                          </TableCell>
                        ) : val === "category_name" ? (
                          <TableCell>
                            <Typography textTransform={"capitalize"}>
                              {row.name[currentLanguage]}
                            </Typography>
                          </TableCell>
                        ) : val === "category_description" ? (
                          <TableCell style={{ width: 600 }}>
                            <Typography
                              variant="body2"
                              textTransform={"capitalize"}
                            >
                              {row.description[currentLanguage]}
                            </Typography>
                          </TableCell>
                        ) : val === "sub_category_name" ? (
                          <TableCell>
                            <Stack
                              gap={1}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.serviceSubCategoryId.activeIcon}
                                sx={{
                                  height: 60,
                                  width: 60,
                                  borderRadius: 2,
                                }}
                              />
                              <Box>
                                <Typography
                                  textTransform={"capitalize"}
                                  fontWeight={600}
                                >
                                  {
                                    row.serviceSubCategoryId.name[
                                      currentLanguage
                                    ]
                                  }
                                </Typography>
                                {/* <Typography variant="body2">
                                  4 (21 Review)
                                </Typography> */}
                              </Box>
                            </Stack>
                          </TableCell>
                        ) : val === "sub_category_description" ? (
                          <TableCell style={{ width: 560 }}>
                            {
                              row.serviceSubCategoryId.description[
                                currentLanguage
                              ]
                            }
                          </TableCell>
                        ) : val === "sub_category_per" ? (
                          <TableCell>
                            {row.serviceSubCategoryId.percentage}%
                          </TableCell>
                        ) : val === "company_per" ? (
                          <TableCell>{row.percentage}%</TableCell>
                        ) : val === "sub_category_cost" ? (
                          <TableCell>
                            <GlobalButton
                              variant={"contained"}
                              btnText={"seePricing"}
                              handleClickBtn={() => handleSeePricing(row)}
                              styleProps={{
                                height: 40,
                                width: 120,
                                borderRadius: 1,
                              }}
                            />
                          </TableCell>
                        ) : val === "sub_category_duration" ? (
                          <TableCell>
                            <GlobalButton
                              variant={"contained"}
                              btnText={"seeDuration"}
                              handleClickBtn={() => handleSeeDuration(row)}
                              styleProps={{
                                height: 40,
                                width: 120,
                                borderRadius: 1,
                              }}
                            />
                          </TableCell>
                        ) : val === "worker_details" ? (
                          <TableCell>
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.profileImg}
                                sx={{ height: "60px", width: "60px" }}
                              />
                              <Stack>
                                <Typography
                                  variant="body1"
                                  fontWeight={600}
                                  color={appcolors.black}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color={appcolors.gunmetal}
                                >
                                  {row.email}/{row.contact}
                                </Typography>

                                <Typography
                                  variant="body2"
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.location?.addressLabel}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "worker_services" ? (
                          <TableCell>_</TableCell>
                        ) : val === "worker_reviews" ? (
                          <TableCell>
                            <Stack>
                              <Rating
                                value={row.rating}
                                precision={0.5}
                                readOnly
                                size="small"
                              />
                              <Typography variant="body2">
                                {row.rating}/5 Rating (
                                {row?.reviews?.length || 0} {t("reviews")})
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val === "status" ? (
                          <TableCell>
                            <FormGroup
                              sx={{
                                "&.MuiFormGroup-root .MuiFormControlLabel-root":
                                  {
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                  },
                                "&.MuiFormGroup-root .MuiFormControlLabel-root .MuiFormControlLabel-label ":
                                  {
                                    fontSize: "0.75rem",
                                  },
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    defaultChecked
                                    checked={row.status}
                                    onChange={(e) =>
                                      handleChangeStatus(
                                        e.target.checked,
                                        row,
                                        index,
                                      )
                                    }
                                  />
                                }
                                label={row.status ? t("open") : t("close")}
                              />
                            </FormGroup>
                          </TableCell>
                        ) : val === "role_name" ? (
                          <TableCell style={{ textTransform: "capitalize" }}>
                            {row.role}
                          </TableCell>
                        ) : val === "assigned_pages" ? (
                          <TableCell>
                            <Button
                              startIcon={
                                expandedRow === index ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )
                              }
                              disableRipple
                              variant="none"
                              sx={{
                                width: "auto",
                                "&:hover": { background: "transparent" },
                              }}
                              onClick={() => handleTogglePagesRow(index)}
                            >
                              {expandedRow === index ? t("less") : t("more")}
                            </Button>
                          </TableCell>
                        ) : val === "worker_review_service" ? (
                          <TableCell>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              gap={1}
                            >
                              <Avatar
                                src={row.serviceImage}
                                sx={{
                                  height: 50,
                                  width: 50,
                                  borderRadius: 2,
                                }}
                              />
                              <Typography
                                variant="body1"
                                fontWeight={500}
                                textTransform={"capitalize"}
                              >
                                {row.serviceName[currentLanguage]}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val === "worker_review_user" ? (
                          <TableCell>
                            <Stack>
                              <Stack
                                direction={"row"}
                                justifyContent={"space-between"}
                              >
                                <Typography
                                  variant="h3"
                                  fontSize={"1rem"}
                                  fontWeight={600}
                                >
                                  {row.username}
                                </Typography>
                                <Rating
                                  value={row.rating}
                                  precision={0.5}
                                  readOnly
                                  size="small"
                                  color="#7922D8"
                                />
                              </Stack>
                              <Typography variant="body2">
                                {row.comment}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val === "service_sub_name_worker" ? (
                          <TableCell sx={{ textTransform: "capitalize" }}>
                            {row?.subServiceName[currentLanguage]}
                          </TableCell>
                        ) : val === "service_sub_name" ? (
                          <TableCell sx={{ textTransform: "capitalize" }}>
                            {row?.subService[currentLanguage] ||
                              row?.subServiceName[currentLanguage]}
                          </TableCell>
                        ) : val === "showUserRole" ? (
                          <TableCell sx={{ textTransform: "capitalize" }}>
                            {row?.role?.role}
                          </TableCell>
                        ) : val === "service_sub_earning" ? (
                          <TableCell sx={{ textTransform: "capitalize" }}>
                            {CURRENCY} {row?.totalEarnings}
                          </TableCell>
                        ) : val === "product_purchase_price_without_vat" ? (
                          <TableCell>{`${CURRENCY} ${row.price}`}</TableCell>
                        ) : val === "product_profit_margin" ? (
                          <TableCell>{`${row.profitMargin}%`}</TableCell>
                        ) : val === "product_discount" ? (
                          <TableCell>{row.discount}</TableCell>
                        ) : val === "actions" ? (
                          <TableCell>
                            {showDetailBtn && (
                              <Box
                                onClick={() =>
                                  handleNavigateToDetail(row, index)
                                }
                                sx={{ cursor: "pointer" }}
                              >
                                <img
                                  src={allIcons.rightArrowIcon}
                                  alt="login-icon"
                                  width={25}
                                />
                                <Typography
                                  variant="body2"
                                  fontSize={"0.75rem"}
                                  color={"#343A40"}
                                >
                                  {t("details")}
                                </Typography>
                              </Box>
                            )}
                            {showActions && (
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                gap={1}
                              >
                                <Button
                                  disableRipple
                                  aria-controls={
                                    openAddEditMenu ? "addEdit-menu" : undefined
                                  }
                                  startIcon={
                                    <MoreVertIcon htmlColor="#000000" />
                                  }
                                  onClick={(e) =>
                                    handleClickAddEditMenu(e, row, index)
                                  }
                                  sx={{
                                    padding: "5px",
                                    minWidth: 0,
                                    "&:hover": {
                                      backgroundColor: "#ffffff",
                                    },
                                  }}
                                />
                                <Menu
                                  id="addEdit-menu"
                                  anchorEl={meunAnchorEl}
                                  open={openAddEditMenu}
                                  onClose={handleCloseAddEditMenu}
                                  MenuListProps={{
                                    "aria-labelledby": "addEdit-menu-button",
                                  }}
                                  sx={{
                                    ".MuiMenu-paper": {
                                      boxShadow: "none",
                                      border: "1px solid grey",
                                    },
                                  }}
                                >
                                  <Stack
                                    direction={"column"}
                                    alignItems={"center"}
                                    spacing={1}
                                    paddingX={1}
                                  >
                                    {showEdit && (
                                      <img
                                        src={allIcons.editIcon}
                                        alt="delete-icon"
                                        width={20}
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          handleEdit(rowData);
                                          handleCloseAddEditMenu();
                                        }}
                                      />
                                    )}
                                    {showDelete && (
                                      <img
                                        src={allIcons.deleteIcon}
                                        alt="delete-icon"
                                        width={20}
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          handleDelete(rowData);
                                          handleCloseAddEditMenu();
                                        }}
                                      />
                                    )}
                                    {showView && (
                                      <RemoveRedEyeOutlinedIcon
                                        onClick={() => {
                                          handleViewDetail(rowData);
                                          handleCloseAddEditMenu();
                                        }}
                                        sx={{
                                          color: "primary.main",
                                          cursor: "pointer",
                                        }}
                                      />
                                    )}
                                  </Stack>
                                </Menu>
                              </Stack>
                            )}
                          </TableCell>
                        ) : (
                          <TableCell>
                            <Typography
                              lineHeight="normal"
                              fontSize={"0.875rem"}
                            >
                              {row[val]}
                            </Typography>
                          </TableCell>
                        )}
                      </React.Fragment>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell
                      colSpan={tableHeader.length}
                      style={{ padding: 0, borderBottom: "none" }}
                    >
                      <Collapse
                        in={expandedRow === index}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Paper
                          elevation={2}
                          sx={{ marginBottom: 0, padding: 2 }}
                        >
                          <Typography
                            variant="h1"
                            fontWeight={600}
                            fontSize={"1rem"}
                          >
                            {t("allModules")}
                          </Typography>
                          <List>
                            {CompanyRoutes?.slice(0, -1).map((valll, _ind) => {
                              let assigned;
                              if (showAdminUserPage) {
                                assigned = row?.role?.pages?.find(
                                  (it) => it.name === valll.name,
                                );
                              } else {
                                assigned = row.pages?.find(
                                  (it) => it.name === valll.name,
                                );
                              }

                              return (
                                <ListItem>
                                  <ListItemIcon>
                                    <img
                                      src={
                                        assigned !== undefined
                                          ? allIcons.checkSquareIcon
                                          : allIcons.uncheckSquareIcon
                                      }
                                      alt="check-icon"
                                      width={20}
                                    />
                                  </ListItemIcon>
                                  <ListItemText secondary={valll.name} />
                                </ListItem>
                              );
                            })}
                          </List>
                        </Paper>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {showPagination && (
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={tableData?.length}
          rowsPerPage={20}
          page={page}
          labelRowsPerPage={t("rowsPerPage")}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </>
  );
}
